var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayThinLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 1,
    viewBox: "0 0 309 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.19954e-8,
    y1: 0.5,
    x2: 309,
    y2: 0.500023,
    stroke: "#4A516B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayThinLine);
export default __webpack_public_path__ + "static/media/gray-thin-line.e182bd7c.svg";
export { ForwardRef as ReactComponent };